import LegalPage from './LegalPage'
import { DISCLAIMER } from './legal'

export default function DisclaimerPage() {
  return <LegalPage {...DISCLAIMER} />
}
